import { useModuleFederationContext, useViewBaseMetadata } from '@msdk/common'
import { CustomColumnProps, Entity, EntityMetadata, FieldValue, ViewColumnDefinition } from '@msdk/definitions'
import { styled, Tooltip } from '@msdk/ui'
import React from 'react'

import { resolveConfig, resolveItem } from '../../../utils'
import { useDynamicViewContext } from '../context'

const MissingComponent = styled('div')`
  width: 90%;
  height: 40px;
  background-color: red;
  color: white;
  text-align: center;
  border-radius: 10px;
  padding: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

interface Props {
  value: FieldValue<any> | null
  row?: Entity
  col: ViewColumnDefinition
  onItemClick?: () => void
}

export function CustomCellRenderer({ row, value, col, onItemClick }: Props) {
  const { viewModel, reload } = useDynamicViewContext()

  const baseMetadata = useViewBaseMetadata(viewModel.entity, viewModel.name) as EntityMetadata
  const modules = useModuleFederationContext()
  const msModule = modules.loadedModules[baseMetadata.msProvider]
  const ImportedComponent = resolveItem(msModule, col.customUI)

  const handleItemClick = () => {
    onItemClick && onItemClick()
  }

  const componentProps: CustomColumnProps = {
    value,
    row,
    reload,
    columnDefinition: col,
    config: resolveConfig(col.config),
    onItemClick: handleItemClick,
  }

  return (
    <>
      {ImportedComponent && <ImportedComponent {...componentProps} />}
      {!ImportedComponent && (
        <Tooltip title={col.customUI}>
          <MissingComponent>{col.customUI}</MissingComponent>
        </Tooltip>
      )}
    </>
  )
}
